export enum EventActionTypes {
    CargoItemsQtyEntered = "CargoItemsQtyEntered",
    CargoPhotoLoaded = "CargoPhotoLoaded",
    CargoVideoLoaded = "CargoVideoLoaded",
    RouteSheetPhotoLoaded = "RouteSheetPhotoLoaded",
    DocumentPhotoLoaded = "DocumentPhotoLoaded",
    RouteRejectedBySupplier = "RouteRejectedBySupplier",
    RouteFinalCommentAdded = "RouteFinalCommentAdded",
}
